import React from "react";
import { interiorPages } from "../../data/content";
export function InteriorPages() {
  return <section className="bg-brand-600 py-8 text-white lg:py-12" aria-labelledby="interior-title" data-id="element-315" data-mp="385h9qs6npy61">
      <div className="mx-auto max-w-5xl px-5" data-id="element-316" data-mp="2u5omj6uca02t">
        <div className="mx-auto max-w-2xl text-center" data-id="element-317" data-mp="2u6zpj4fyn3sv">
          <h2 id="interior-title" className="font-display text-[21px] font-extrabold leading-tight tracking-tight sm:text-3xl" data-id="element-318" data-mp="2y68lmfyh3drl">
            Recursos que podés llevar <span className="text-brand-100 underline decoration-sun decoration-[3px] underline-offset-[6px]" data-id="element-319" data-mp="3lyfkblro7wu6">directamente a tu trabajo</span>
          </h2>
          <p className="mt-2.5 text-[13px] font-semibold leading-snug text-white sm:text-base" data-id="element-320" data-mp="3d2zl0p85cph7">
            Dejá de perder tiempo buscando ejercicios, actividades o ideas por separado. Tené un material organizado para preparar tus sesiones con mayor facilidad.
          </p>
        </div>

        <ul className="mx-auto mt-5 grid max-w-3xl grid-cols-2 gap-2 sm:grid-cols-3 lg:mt-7 lg:gap-2.5" data-id="element-321" data-mp="dgswrqitdz4l">
          {interiorPages.map(p => {
          const Icon = p.icon;
          return <li key={p.label} className="flex items-center gap-2.5 rounded-xl bg-white/10 px-3 py-2.5 ring-1 ring-white/15" data-id="element-322" data-mp="3doslc6aojau3">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white text-brand-600" data-id="element-323" data-mp="3segntaulkfje">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-324" data-mp="3nl41j7de4ktt" />
                </span>
                <span className="min-w-0 flex-1 font-display text-[13px] font-bold leading-tight text-white sm:text-sm" data-id="element-325" data-mp="57eao2xy4ifp">{p.label}</span>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}